import logInternalLinkClick from "lib/ga/internalLinkClick";
import Link from "next/link";
import styles from './sponsored.module.css'
import globalStyles from '../result.module.css';
interface Props {
    unsponsoredText: string;
    id: number;
}

const UnsponsoredBannerDisplay = ({unsponsoredText, id}: Props) => {
    return (
      <div className={styles.UnsponsoredBanner}>
          <div className={`${styles.bannerContent} ${globalStyles.pageContainer}`} style={{padding: 0}}>
              <Link href="/landlord-pricing" prefetch={false} passHref>
              <div className={styles.unsponsoredWrapper} onClick={(e) => logInternalLinkClick("Scheme unsponsored Banner", '/landlord-pricing', id)}>
                  <p className={styles.nonSponsoredBannerText}>{unsponsoredText}</p>
              </div>
              </Link>
          </div>
      </div>
    )
}

export default UnsponsoredBannerDisplay;